import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import PropTypes from 'prop-types';
import RECICLED from 'components/photos/purchaseDelivery/recicled.png';

const ReportPurchseDelivery = ({
  dataPurchaseDelivery,
  initialStatePurchaseDelivery,
  setDataPurchaseDelivery,
  setViewPDF,
  typeOfList,
}) => {
  const headerPrinterPurchase = useSelector((state) => state.formatDIUser.headerPrinter);

  // ------------------ Utils ------------------
  function formatNumber(num) {
    try {
      return Number(num || 0).toLocaleString('es-ES', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    } catch (_) {
      return '0,00';
    }
  }
  function formatNumberEuro(num) {
    try {
      return (
        Number(num || 0).toLocaleString('es-ES', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }) + ' €'
      );
    } catch (_) {
      return '0,00 €';
    }
  }
  function groupTaxes(lines) {
    const taxGroups = [];
    (lines || []).forEach((line) => {
      const { tax = 0, amount = 0, estimatedprice = 0, discount = 0, taxincluded = false } = line;
      const taxableAmount = amount * estimatedprice * (1 - discount / 100);
      if (tax !== 0 && !taxincluded && taxableAmount !== 0) {
        const taxAmount = taxableAmount * (tax / 100);
        const existing = taxGroups.find((g) => g.taxRate === tax);
        if (existing) existing.taxAmount += taxAmount;
        else taxGroups.push({ taxRate: tax, taxAmount });
      }
    });
    return taxGroups;
  }
  function getDateFormated(getDate) {
    const meses = [
      'Enero',
      'Febrero',
      'Marzo',
      'Abril',
      'Mayo',
      'Junio',
      'Julio',
      'Agosto',
      'Septiembre',
      'Octubre',
      'Noviembre',
      'Diciembre',
    ];
    const hoy = getDate ? new Date(getDate) : new Date();
    const dia = hoy.getDate();
    const mes = meses[hoy.getMonth()];
    const año = hoy.getFullYear();
    return `${dia} de ${mes} de ${año}`;
  }

  useEffect(() => {
    if (!dataPurchaseDelivery) return;

    const doc = new jsPDF({ orientation: 'p', unit: 'mm', format: [210, 297] });
    const bottomMargin = 270; // límite inferior de contenido por página
    const conceptLineHeight = 4; // alto de cada línea de texto en la columna concepto

    // ------- Helpers de dibujo -------
    const drawTableHeader = () => {
      doc.setLineDash([]);
      doc.setFillColor('#FFFFFF');
      doc.setLineWidth(0.3);
      doc.rect(15, 60, 27, 6, 'FD'); // Cantidad
      doc.rect(42, 60, 120, 6, 'FD'); // Concepto
      doc.rect(155, 60, 20, 6, 'FD'); // Precio
      doc.rect(175, 60, 20, 6, 'FD'); // Importe

      doc.setFont('helvetica', 'bold');
      doc.setFontSize(6);
      doc.text('CANTIDAD/TONELADAS', 16, 64, 'left');
      doc.setFontSize(10);
      doc.text('CONCEPTO', 98, 64, 'center');
      doc.text('PRECIO', 165, 64, 'center');
      doc.text('IMPORTE', 185, 64, 'center');
    };

    const drawPageHeader = () => {
      let yOffset = 12;
      doc.addImage(RECICLED, 'PNG', 37, 4, 5, 5);

      doc.setFont('helvetica', 'bold');
      doc.setFontSize(16);
      doc.text(typeOfList === '1' ? 'ALBARÁN ENTRADA' : 'ALBARÁN', 195, yOffset - 4, 'right');

      doc.setFont('helvetica', 'normal');
      doc.setFontSize(14);
      const formatted_id = (dataPurchaseDelivery.purchasenote || '').toString().padStart(8, '0');
      doc.text(`${formatted_id}`, 195, yOffset + 2, 'right');

      // Cabecera impresa multilinea
      if (headerPrinterPurchase && headerPrinterPurchase.length > 0) {
        let counter = 0;
        headerPrinterPurchase.split('\n').forEach((line) => {
          if (counter === 0) {
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(8);
          } else {
            doc.setFont('helvetica', 'normal');
            doc.setFontSize(7);
          }
          counter++;
          doc.text(line, 40, yOffset, 'center');
          yOffset += 2.5;
        });
      }

      // Bloque datos "He recibido de"
      yOffset = 38;
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(12);
      const newDate =
        dataPurchaseDelivery.datepurchase && dataPurchaseDelivery.datepurchase !== ''
          ? getDateFormated(dataPurchaseDelivery.datepurchase)
          : '';
      doc.text(`${newDate}`, 195, yOffset - 8, 'right');

      doc.setFontSize(10);
      doc.text('He recibido de :', 15, yOffset, 'left');
      doc.text('Natrícula ', 15, yOffset + 5, 'left');
      doc.text('Marca/Modelo', 77, yOffset + 5, 'left');
      doc.text('Nº Bastidor ', 15, yOffset + 10, 'left');
      doc.text('Dirección ', 15, yOffset + 15, 'left');
      doc.text('E-mail ', 15, yOffset + 20, 'left');

      const marcaModelVehicle = `${(dataPurchaseDelivery.vehicle_marca || '').trim()} - ${(dataPurchaseDelivery.vehicle_model || '').trim()}`;
      const street = `${(dataPurchaseDelivery.opt_tras_street || '').trim()} - ${(dataPurchaseDelivery.opt_tras_postalcode_code || '').trim()} - ${(dataPurchaseDelivery.opt_tras_postalcode_name || '').trim()}`;

      // Líneas punteadas
      doc.setLineDash([0.2, 0.2], 0);
      doc.line(42, yOffset, 195, yOffset);
      doc.line(34, yOffset + 5, 75, yOffset + 5);
      doc.line(102, yOffset + 5, 195, yOffset + 5);
      doc.line(35, yOffset + 10, 195, yOffset + 10);
      doc.line(32, yOffset + 15, 195, yOffset + 15);
      doc.line(26, yOffset + 20, 195, yOffset + 20);

      doc.text(`${(dataPurchaseDelivery.opt_tras_tradename || '').substr(0, 78)}`, 42, yOffset - 1, 'left');
      doc.text(`${(dataPurchaseDelivery.opt_tras_licenseplate || '').substr(0, 20)}`, 34, yOffset + 4, 'left');
      doc.text(`${marcaModelVehicle.substr(0, 30)}`, 102, yOffset + 4, 'left');
      doc.text(`${(dataPurchaseDelivery.vehiclestore_frame || '').substr(0, 78)}`, 35, yOffset + 9, 'left');
      doc.text(`${street.substr(0, 78)}`, 32, yOffset + 14, 'left');
      doc.text(`${(dataPurchaseDelivery.opt_tras_email || '').substr(0, 78)}`, 26, yOffset + 19, 'left');

      doc.setLineDash([]);
    };

    const addNewPageWithHeaders = () => {
      doc.addPage();
      drawPageHeader();
      drawTableHeader();
    };

    // --------- Render ---------
    drawPageHeader();
    drawTableHeader();

    let yOffset = 68; // comienzo del área de líneas
    let totalPurchase = 0;
    let totalTax = 0;

    const lines = dataPurchaseDelivery.linespurchasedelivery || [];
    const taxGroups = groupTaxes(lines);

    // Columnas y medidas
    const colX = { qty: 15, concept: 42, price: 155, amount: 175 };
    const colW = { qty: 27, concept: 120, price: 20, amount: 20 };
    const textX = { qty: 41, concept: 43, price: 173, amount: 193 };
    const maxConceptWidth = colW.concept - 2; // margen interno

    for (let i = 0; i < lines.length; i++) {
      const line = lines[i];

      // Construcción de las líneas del concepto (nombre + subtítulo textarea + info)
      let conceptLines = doc.splitTextToSize((line.article_namees || '').toString(), maxConceptWidth);

      if (line.article_subtitlees && line.article_subtitlees.trim() !== '') {
        const raw = line.article_subtitlees.replace(/\r/g, '');
        const paragraphs = raw.split('\n');
        paragraphs.forEach((p) => {
          const wrapped = doc.splitTextToSize(p, maxConceptWidth);
          conceptLines = conceptLines.concat(wrapped);
        });
      }

      let info = '';
      if (line.applytypesofsize || line.applycolor || line.applynumserial) {
        info += line.articlecolor_namees ? line.articlecolor_namees + ' ' : '';
        info += line.typeofsize_namees ? line.typeofsize_namees + ' ' : '';
        info += line.serialnumber ? ' ' + line.serialnumber : '';
        if (info.trim() !== '') {
          const wrappedInfo = doc.splitTextToSize(info.trim(), maxConceptWidth);
          conceptLines = conceptLines.concat(wrappedInfo);
        }
      }

      if (!conceptLines || conceptLines.length === 0) conceptLines = [''];

      const boxHeight = Math.max(conceptLineHeight, conceptLines.length * conceptLineHeight);

      // Salto de página si no cabe la fila completa
      if (yOffset + boxHeight > bottomMargin) {
        addNewPageWithHeaders();
        yOffset = 68;
      }

      // Cálculos económicos
      const unitPrice = (line.estimatedprice || 0) * (1 - ((line.discount || 0) / 100));
      const lineTotal = (line.amount || 0) * unitPrice;
      totalPurchase += lineTotal;
      if (!line.taxincluded) {
        totalTax += lineTotal * ((line.tax || 0) / 100);
      }

      // Fondo de fila (cajas)
      doc.setFillColor('#FFFFFF');
      doc.setLineWidth(0.2);
      doc.rect(colX.qty, yOffset - 3, colW.qty, boxHeight, 'FD');
      doc.rect(colX.concept, yOffset - 3, colW.concept, boxHeight, 'FD');
      doc.rect(colX.price, yOffset - 3, colW.price, boxHeight, 'FD');
      doc.rect(colX.amount, yOffset - 3, colW.amount, boxHeight, 'FD');

      // Cantidad
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(8);
      doc.text(`${formatNumber(line.amount || 0)}`, textX.qty, yOffset, 'right');

      // Concepto multilínea
      let yText = yOffset;
      conceptLines.forEach((t) => {
        doc.text(t, textX.concept, yText, 'left');
        yText += conceptLineHeight;
      });

      // Precio/Importe alineados a la última línea del bloque
      const priceY = yOffset + conceptLineHeight * (conceptLines.length - 1);
      doc.text(`${formatNumberEuro(unitPrice)}`, textX.price, priceY, 'right');
      doc.text(`${formatNumberEuro(lineTotal)}`, textX.amount, priceY, 'right');

      yOffset += boxHeight;
    }

    // ---- Bloque Totales (solo al final) ----
    const ensureSpace = (needed) => {
      if (yOffset + needed > bottomMargin) {
        addNewPageWithHeaders();
        yOffset = 68;
      }
    };

    // Línea separadora
    ensureSpace(8);
    doc.setFillColor('#FFFFFF');
    doc.setLineWidth(0.3);
    doc.line(15, yOffset - 3, 195, yOffset - 3);
    doc.rect(175, yOffset - 3, 20, 4, 'FD');
    yOffset += 4;
    doc.rect(175, yOffset - 3, 20, 4, 'FD');

    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9);
    doc.text('SUBTOTAL', 173, yOffset - 4, 'right');
    doc.text(`${formatNumberEuro(totalPurchase)}`, 193, yOffset - 4, 'right');
    yOffset += 4;

    // IGIC por grupos (taxGroups) SOLO aquí (última página)
    if (taxGroups && taxGroups.length > 0) {
      taxGroups.forEach((group) => {
        ensureSpace(6);
        doc.setFillColor('#FFFFFF');
        doc.setLineWidth(0.3);
        doc.rect(175, yOffset - 3, 20, 4, 'FD');
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(9);
        doc.text(`IGIC ${group.taxRate}%:`, 173, yOffset, 'right');
        doc.text(`${formatNumberEuro(group.taxAmount)}`, 193, yOffset, 'right');
        yOffset += 4;
      });
    } else {
      ensureSpace(6);
      doc.setFillColor('#FFFFFF');
      doc.setLineWidth(0.3);
      doc.rect(175, yOffset - 3, 20, 4, 'FD');
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(9);
      doc.text('IGIC', 173, yOffset, 'right');
      yOffset += 4;
    }

    // TOTAL
    ensureSpace(6);
    doc.setFillColor('#FFFFFF');
    doc.setLineWidth(0.3);
    doc.rect(175, yOffset - 3, 20, 4, 'FD');
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(9);
    doc.text('TOTAL', 173, yOffset, 'right');
    doc.text(`${formatNumberEuro(totalPurchase + totalTax)}`, 193, yOffset, 'right');

    // Forma de pago y referencia cliente
    const paymentData = `FORMA DE PAGO: ${dataPurchaseDelivery.payment_namees || ''}`;
    ensureSpace(16);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9);
    doc.text(`${paymentData}`, 195, yOffset + 8, 'right');

    if (dataPurchaseDelivery.ownnumberpurchase && dataPurchaseDelivery.ownnumberpurchase.trim() !== '') {
      const referenceData = `Referencia Cliente: ${dataPurchaseDelivery.ownnumberpurchase.trim()}`;
      doc.text(`${referenceData}`, 195, yOffset + 12, 'right');
    }

    // ---- Firmas ----
    const drawSignatures = () => {
      let yBase = 260; // mismo layout que tu versión previa
      if (yBase < yOffset + 20) {
        addNewPageWithHeaders();
        yBase = 260;
      }
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(8);
      doc.text('DNI nº', 82, yBase + 16, 'left');
      doc.setLineDash([0.2, 0.2], 0);
      doc.line(92, yBase + 16, 120, yBase + 16);
      doc.setLineDash([]);

      if (dataPurchaseDelivery.signature_dispatched_by) {
        try {
          doc.addImage(`${dataPurchaseDelivery.signature_dispatched_by}`, 'PNG', 17, yBase + 2, 20, 20);
        } catch (_) {}
      }
      if (dataPurchaseDelivery.signature_client) {
        try {
          doc.addImage(`${dataPurchaseDelivery.signature_client}`, 'PNG', 95, yBase + 2, 20, 20);
        } catch (_) {}
      }
      doc.text('Despachado por', 18, yBase + 3, 'left');
      doc.text('Conforme Cliente', 100, yBase + 3, 'center');

      // Disclaimer legal (al pie)
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(7);
      doc.text(
        "*Este documento no tiene valor como  'Certificado Acreditativo de Gestión de Residuos de la Construcción'  según el art. 7.c. del Real Decreto 105/2008",
        12,
        yBase + 24,
        'left'
      );
    };

    drawSignatures();

    // ---- Salida ----
    const pdfBlob = doc.output('blob');
    const url = URL.createObjectURL(pdfBlob);
    window.open(url, '_blank');

    // Limpieza de estado UI
    setViewPDF(false);
    setDataPurchaseDelivery(initialStatePurchaseDelivery);

    // Revoke tras abrir (minor: no romper link en Edge). Si quieres, retrasar con setTimeout.
    setTimeout(() => URL.revokeObjectURL(url), 10000);
  }, [dataPurchaseDelivery, setViewPDF, setDataPurchaseDelivery, initialStatePurchaseDelivery, headerPrinterPurchase, typeOfList]);

  return null; // no renderiza nada
};

ReportPurchseDelivery.propTypes = {
  dataPurchaseDelivery: PropTypes.object.isRequired,
  initialStatePurchaseDelivery: PropTypes.object.isRequired,
  setDataPurchaseDelivery: PropTypes.func.isRequired,
  setViewPDF: PropTypes.func.isRequired,
  typeOfList: PropTypes.string,
};

export default ReportPurchseDelivery;
